import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Whatsapp from './Whatsapp';
import { ZoomableImage } from './ImageLightbox';
import { LHIC_CONTENT, LHIC_GALLERY } from '../data/lhicContent';

export default function Lhic() {
  return (
    <div className="main-wrapper page page-lhic">
      <Navbar />

      <div className="content-wrapper">
        <div className="about-us" data-aos="fade-up">
          <div className="about-us-title text-center">
            <div className="container">
              <h1 className="heading-bold text-uppercase">{LHIC_CONTENT.title}</h1>
              <p className="page-hero-subtitle">
                Empowering the next generation of chemical engineering and technology entrepreneurs
              </p>
            </div>
          </div>
        </div>

        <section className="lhic-gallery" data-aos="fade-up">
          <div className="container">
            <p className="lhic-gallery__intro">Tap or click any photo to view full size.</p>
            <div className="lhic-gallery__grid">
              {LHIC_GALLERY.map((photo) => (
                <ZoomableImage
                  key={photo.src}
                  src={photo.src}
                  alt={photo.alt}
                  caption={photo.caption}
                />
              ))}
            </div>
          </div>
        </section>

        <Whatsapp />
      </div>

      <Footer />
    </div>
  );
}
